import ActionTypes from "../constants/action_types";

export default function clearLlmRun() {
  return {
    type: ActionTypes.LLM_RUN_CLEAR.SUCCESS,
  };
}
